import  * as API from '@/api/scan-cart'


// initial state
const state ={
	scan_total_amount: 0, //总量
	scan_total_price: 0.00, // 总价
	scan_height: 0, // TODO
	scan_cartGoods: [], // 扫码购中选中的商品
}

// mutations
const mutations = {
	//计算购物车总量和总价
	scanCalculationAmount(state, amount) {
		state.scan_total_amount = amount;
	},
	scanCalculationPrice(state, price) {
		state.scan_total_price = price;
	},
	setScanHeight(state, value) {
		state.scan_height = value;
	},
	saveScanSelectedCartGoods(state, payload) {		
		state.scan_cartGoods = payload
	},
	clearScanSelectedCartGoods(state) {
		state.scan_cartGoods = []
	},
}

// actions 
const actions = {
	fetchScreenCartList({ commit, state }, params) {
		return new Promise((resolve, reject) => {
			API.getScreenCartList(params.operator_uid).then(
				response => {
					if (response && response.error_code ==0) {
						commit('saveScanSelectedCartGoods', response.goods_groups)
					}
					resolve(response)
				},
				error => {
					reject(error)
				}
			)
		})
	}
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/scancart.js